


import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import AliceCarousel from "react-alice-carousel";
import "react-alice-carousel/lib/alice-carousel.css";
import HomeProductCard from "../Home/HomeProductCard";
import api from "../../../config/api";

function HomeCarousel({ data = [], section }) {
  const [wishlist, setWishlist] = useState([]); // State to store wishlist products

  // Use separate selectors to avoid unnecessary re-renders
  const isLoggedIn = useSelector((state) => !!state.auth.user);
  const token = useSelector((state) => state.auth.user?.jwt);

  // Fetch Wishlist once if the user is logged in
  useEffect(() => {
    const fetchWishlist = async () => {
      try {
        const response = await api.get("/api/wishlist/get", {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        setWishlist(response.data.wishlist.products || []); // Save wishlist products or fallback to empty array
      } catch (error) {
        console.error("Error fetching wishlist:", error);
      }
    };

    if (isLoggedIn) {
      fetchWishlist();
    }
  }, [isLoggedIn, token]);

  // Responsive settings for the carousel
  
  const responsive = {
    0: { items: 2 },
    720: { items: 3 },
    1024: { items: 5 },
  };

  // Check if data is valid and is an array before using slice
  const items = Array.isArray(data)
    ? data.slice(0, 10).map((item) => (
        <HomeProductCard
          key={item._id}
          product={item}
          wishlist={wishlist} // Pass wishlist to each card
        />
      ))
    : [];

  return (
    <div>
      <div>
        <h1 className="text-2xl m-5 text-center font-bold">{section}</h1>
        <AliceCarousel
          mouseTracking
          autoPlay
          disableButtonsControls
          infinite
          autoPlayInterval={2000}
          items={items}
          responsive={responsive}
          controlsStrategy="alternate"
        />
      </div>
    </div>
  );
}

export default HomeCarousel;
